<template>
  <div class="w-full bg-white md:pt-16 font-inter">
    <!-- Cabeçalho com título e metadados -->
    <div class="text-left py-3 ">
      <section class="container mx-auto px-4 mb-8">
        <div class="max-w-4xl mx-auto">

          <PhArrowLeft
            class="text-gray-500 w-7 h-7 cursor-pointer"
            @click="back(Noticias)"
          />

          <!-- Autor -->
          <div class="flex items-center gap-4 mb-1">
            <img
              :src="
                notice?.author?.image_profile !== null && 
                notice?.author?.image_profile !== undefined ? 
                fileUrl + notice?.author?.image_profile : 
                'https://i.pravatar.cc/100'
              "
              alt="Autor"
              class="w-12 h-12 rounded-full object-cover"
            />
            <div class="text-gray-400">
              <p class="text-black font-semibold text-xl flex flex-col" v-if="notice?.author?.name">
                <small class="text-gray-400 text-xs font-normal">
                  autor
                </small>
                {{ notice?.author?.name }}
              </p>
              <p class="text-sm flex flex-col -mt-2">
                <small>
                  escrito em
                </small>
                {{ formatDate(notice.created_at) }}
              </p>
            </div>
          </div>

          <!-- Título -->
          <h1 class="text-3xl md:text-5xl font-extrabold leading-tight mb-4">
            {{ notice?.title }}
          </h1>

          <!-- Subtítulo -->
          <p class="text-gray-400 text-base mb-1">
            {{ notice?.resum }}
          </p>
        </div>
      </section>

      <!-- Corpo da notícia -->
      <section class="container mx-auto px-4 text-black">
        <div
          class="max-w-4xl mx-auto prose prose-invert prose-lg"
          v-html="notice?.content"
        >
        </div>
      </section>
    </div>

    <!-- Outros conteúdos relacionados -->
    <!-- <section class="container mx-auto mt-16"> -->
      <section class="px-6 md:px-20 py-10" v-if="lastEvents?.length">
        <h2 class="text-xl md:text-2xl font-semibold mb-4 uppercase text-start">
          VEJA TAMBÉM
        </h2>

        <!-- <div class="relative overflow-x-auto"> -->
         <!-- <div class="flex gap-4 p-1"> -->
          <Carrossel>
            <CardEventoPreview
              v-for="(item, index) in lastEvents"
              :key="index"
              :image="item.banner !== null && item.banner !== '[]' ? fileUrl + item.banner : banner"
              :title="item.title"
              :date="formatDate(item.date)"
              :live="item.is_live"
              @click="watchEvent(item)"
            />
          </Carrossel>
          <!-- </div> -->
        <!-- </div>  -->

      </section>
    <!-- </section> -->
  </div>
</template>

<script setup>
import { onBeforeMount, computed, markRaw } from 'vue'
import CardEventoPreview from '../auth/components/CardEventoPreview.vue'

import { dataShared } from '@/shared/store'
import { formatDate } from '@/utils/formaters'
import { PhArrowLeft } from '@phosphor-icons/vue'
import Noticias from './noticias.vue'
import Carrossel from '../auth/components/_partials/Carrossel.vue'
import SharedService from '@/shared/services/shared'
import { showToast as toast } from '@/helpers/UseToasts'
import router from '@/router'

const lastEvents = computed(() => dataShared.getters.getEvents)
const notice = computed(() => dataShared.getters.seeNoticeActivated)
const banner = require('@/assets/image.png')
const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'

function back (value) {
  dataShared.dispatch('setComponentActive', markRaw(value))
}

async function watchEvent (event) {
  dataShared.dispatch('activeLoading')

  await SharedService.watchEventById(event?.id)
    .then(res => {
      dataShared.dispatch('setEventToPurchase', event?.id)

      if (res.data.success == false) {
        dataShared.dispatch('desactiveLoading')
        toast('Aviso', 'Adquira acesso ao evento', 'info')
        return router.push(`/purchase/${event?.id}/event`)
      }

      dataShared.dispatch('desactiveLoading')
      dataShared.dispatch('setLiveActive', event)
      router.push(`/live/${event?.id}`)
    }).catch(err => {
      console.log(err)
    })
}

onBeforeMount(() => {
  window.scrollTo(0, 0)
})
</script>

<style lang="scss" scoped>
p {
  margin: 10px 0;
}
</style>
